import React, { PropsWithChildren } from "react"
import i18nData from "@rogue_4/locales/zh-CN.json"
import { PropsWithStyle, StyledComponent } from "@rogue_4/types"
import classNames from "classnames"

import { i18n } from "@/utils/i18n"
import { IGameEquip } from "../../type"

import styles from "./index.module.less"

export const CharacterImage: StyledComponent<
    PropsWithChildren<{
        key: string
        label: string
        onClick?: () => void
    }>
> = ({ className, style, key, label, onClick, children }) => {
    return (
        <div
            className={classNames(styles.equipFrame, className)}
            style={style}
            onClick={onClick}
        >
            <div className={styles.bg}></div>
            <div className={classNames(styles.img, styles[key])}>
                {children}
            </div>
            {label && <div className={styles.label}>{label}</div>}
        </div>
    )
}

const EquipFrame = React.forwardRef<
    HTMLDivElement,
    PropsWithStyle<{
        equip?: IGameEquip
        noType?: boolean
        label?: string
        onClick?: () => void
    }>
>(({ className, style, equip, noType, label, onClick }, ref) => {
    return (
        <div
            ref={ref}
            onClick={onClick}
            className={classNames(
                styles.equipFrame,
                !equip && styles.disabled,
                className
            )}
            style={style}
        >
            <div className={styles.bg}></div>
            <div
                className={styles.img}
                style={{ backgroundImage: `url(${equip?.image})` }}
            ></div>
            {!noType && (
                <div
                    className={classNames(
                        styles.type,
                        equip && styles[equip.type]
                    )}
                ></div>
            )}
            <div
                className={classNames(
                    styles.label,
                    equip && equip.name.length > 8 && styles.small
                )}
            >
                {label ??
                    (equip
                        ? equip.name
                        : i18n(i18nData, "rogue_4.game.craft.equip.miss"))}
            </div>
        </div>
    )
})
EquipFrame.displayName = "EquipFrame"

export default EquipFrame
